import { Component, inject } from "@angular/core";
import { CommonModule } from "@angular/common";
import { Icon } from "@malirang/front-share";
import { DocumentStore } from "../../store/document.store";

@Component({
    selector: "app-document-back-button",
    templateUrl: "./document-back-button.html",
    styleUrls: ["./document-back-button.css"],
    imports: [CommonModule, Icon],
})
export class DocumentBackButton {
    readonly documentStore = inject(DocumentStore);

    handleBack() {
        this.documentStore.goBack();
    }
}
